import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-lg-popup-text-box',
  templateUrl: './popup-text-box.component.html',
  styleUrls: ['./popup-text-box.component.scss']
})
export class PopupTextBoxComponent implements OnInit {
  @Input() popupSettings: FormGroup;

  constructor() {}

  ngOnInit() {}
}
